import axios from './index'
import prefix_ms from './prefix'

/** 获取积分商品列表 */
export const rewardPointGoodsList = (params) => {
  return axios.request({
    url: `${prefix_ms}/rewardPointGoods/list`,
    method: 'get',
    params: params,
  })
}

/** 获取用户积分兑换记录 */
export const rewardPointGoodsHistory = (params) => {
  return axios.request({
    url: `${prefix_ms}/userRewardPointHis/exchange/history`,
    method: 'get',
    params: params,
  })
}





//////////////////
// WEBPACK FOOTER
// ./app/api/scoreshop.js
// module id = null
// module chunks = 